<div class="alert alert-secondary mb-0">
    {{ title || 'Lista je trenutno prazna' }}
</div>
